import { handleRequest } from '@/utils';
import { addDialogue } from '@/utils/sessionUtils';

const handleClickOtherFrequentlyAsked = (content: string, params: Record<string, any>, cb?: (res: any) => void) => {
  const curPos = addDialogue({
    from: 'user',
    type: 'Msg',
    data: { content },
  });

  if (typeof curPos === 'number') {
    handleRequest('postMessage', params, { curPos }).then((res: any) => {
      cb?.(res);
    });
  }
};

export default handleClickOtherFrequentlyAsked;
